import { Button, Card, Image } from "antd";
import FileUploadIcon2 from "../_icons/FileUploadIcon2";

interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateFileUpload({ data, viewOnly }: Props) {
  return (
    <>
      <Card className="mt-4">
        <div className=" justify-start text-zinc-700 text-base font-medium">
          {data?.question_title}
        </div>
        {viewOnly || data?.answer ? (
          <Image
            wrapperClassName="overflow-hidden"
            className="mt-4"
            height={196}
            src={data?.answer}
          />
        ) : (
          <div className="mt-4">
            <div className=" justify-start text-slate-600 text-sm font-normal mb-3">
              Upload {data?.maximum_num_of_files}{" "}
              {data?.allow_only_specific_file_type === true &&
                `Supported file: ${data?.allow_only_specific_file_type_checkbox?.join(
                  ", ",
                )}`}
              . Max {data?.maximum_file_size_mb} MB
            </div>

            <Button
              icon={
                <FileUploadIcon2
                  className="!mt-1 w-4 h-4"
                  currentColor="#ffffff"
                />
              }
              type="primary"
              className="sm-button !px-3 !pt-2"
            >
              Add File
            </Button>
          </div>
        )}
      </Card>
    </>
  );
}
